import { render, staticRenderFns } from "./BtnDevolverRequisicao.vue?vue&type=template&id=e1c2860a"
import script from "./BtnDevolverRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnDevolverRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports